import { useState, FormEvent } from 'react';

export default function ContactSection() {
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitting(true);
    const form = e.currentTarget;
    const data = new URLSearchParams();
    new FormData(form).forEach((value, key) => {
      data.append(key, value as string);
    });
    try {
      await fetch('https://readdy.ai/api/form/d72j0ciaegmdqoca7v8g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  };

  const contacts = [
    { icon: 'ri-phone-line', label: 'Phone', value: '+1 (555) 123-4567' },
    { icon: 'ri-mail-line', label: 'Email', value: 'hello@eclat-gen.com' },
    { icon: 'ri-map-pin-line', label: 'Office', value: '123 Innovation Drive\nBoston, MA 02115\nUnited States' },
  ];

  return (
    <section id="contact" className="py-24" style={{ background: 'linear-gradient(180deg, #0e0e1a 0%, #09090f 100%)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <span className="inline-block text-xs font-semibold tracking-[0.25em] uppercase mb-4" style={{ color: '#c9a84c' }}>
            Connect
          </span>
          <h2 className="text-4xl font-light text-white mb-4 tracking-tight">
            Let&apos;s{' '}
            <span style={{ background: 'linear-gradient(135deg, #c9a84c, #e8c87a)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', fontWeight: 700 }}>
              Engineer
            </span>{' '}
            Something Brilliant
          </h2>
          <p className="text-lg text-white/45 font-light">Tell us about your vision — we&apos;ll design the path forward</p>
        </div>

        <div className="grid lg:grid-cols-3 gap-10">
          {/* Form */}
          <div className="lg:col-span-2">
            <div className="p-10" style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(201,168,76,0.15)', borderRadius: '12px' }}>
              {submitted ? (
                <div className="text-center py-12">
                  <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4" style={{ background: 'rgba(201,168,76,0.1)', border: '1px solid rgba(201,168,76,0.3)', borderRadius: '50%' }}>
                    <i className="ri-check-line text-3xl" style={{ color: '#c9a84c' }} />
                  </div>
                  <h3 className="text-2xl font-semibold text-white/90 mb-2">Message Received</h3>
                  <p className="text-white/45 font-light">Thank you for reaching out. Our team will connect with you shortly.</p>
                </div>
              ) : (
                <form
                  id="eclat-gen-contact-form"
                  data-readdy-form
                  className="space-y-6"
                  onSubmit={handleSubmit}
                >
                  <div className="grid md:grid-cols-2 gap-6">
                    {[
                      { name: 'first_name', label: 'First Name', placeholder: 'John' },
                      { name: 'last_name', label: 'Last Name', placeholder: 'Doe' },
                    ].map((f) => (
                      <div key={f.name}>
                        <label className="block text-xs font-semibold text-white/50 tracking-[0.15em] uppercase mb-2">{f.label}</label>
                        <input
                          name={f.name}
                          className="w-full px-4 py-3 text-sm text-white/80 placeholder-white/20 outline-none transition-all duration-300 focus:border-[#c9a84c]"
                          style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(201,168,76,0.15)', borderRadius: '6px' }}
                          placeholder={f.placeholder}
                          required
                        />
                      </div>
                    ))}
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-white/50 tracking-[0.15em] uppercase mb-2">Email</label>
                    <input
                      name="email"
                      type="email"
                      className="w-full px-4 py-3 text-sm text-white/80 placeholder-white/20 outline-none transition-all duration-300 focus:border-[#c9a84c]"
                      style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(201,168,76,0.15)', borderRadius: '6px' }}
                      placeholder="john@company.com"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-white/50 tracking-[0.15em] uppercase mb-2">Company</label>
                    <input
                      name="company"
                      className="w-full px-4 py-3 text-sm text-white/80 placeholder-white/20 outline-none transition-all duration-300"
                      style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(201,168,76,0.15)', borderRadius: '6px' }}
                      placeholder="Your Company"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-white/50 tracking-[0.15em] uppercase mb-2">Message</label>
                    <textarea
                      name="message"
                      rows={4}
                      maxLength={500}
                      className="w-full px-4 py-3 text-sm text-white/80 placeholder-white/20 outline-none transition-all duration-300 resize-none"
                      style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(201,168,76,0.15)', borderRadius: '6px' }}
                      placeholder="Tell us about your vision..."
                      required
                    />
                  </div>
                  <button
                    type="submit"
                    disabled={submitting}
                    className="w-full py-3 text-sm font-semibold whitespace-nowrap cursor-pointer transition-all duration-300 disabled:opacity-60 tracking-wide hover:opacity-90"
                    style={{ background: 'linear-gradient(135deg, #c9a84c, #e8c87a)', color: '#09090f', borderRadius: '6px' }}
                  >
                    {submitting ? 'Sending...' : 'Send Message'}
                  </button>
                </form>
              )}
            </div>
          </div>

          {/* Contact Info */}
          <div className="space-y-5">
            {contacts.map((c) => (
              <div
                key={c.label}
                className="p-6"
                style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(201,168,76,0.12)', borderRadius: '10px' }}
              >
                <div className="w-10 h-10 flex items-center justify-center mb-4" style={{ background: 'rgba(201,168,76,0.1)', border: '1px solid rgba(201,168,76,0.2)', borderRadius: '8px' }}>
                  <i className={`${c.icon} text-lg`} style={{ color: '#c9a84c' }} />
                </div>
                <div className="text-xs font-semibold tracking-[0.2em] uppercase mb-1" style={{ color: '#c9a84c' }}>{c.label}</div>
                <p className="text-sm text-white/55 font-light whitespace-pre-line">{c.value}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
